import { ISendMessagePayload } from '../../../actions/sendMessage';
import { TAppState } from '../../../types/appState';
import { TOutcomingStatus } from '../../../types/messages';
import { removeMessageFromChat, insertMessageIntoChatMessages } from '../../../utils/message';

export function updateState(
  state: TAppState,
  { message, messageId, messagesMap }: ISendMessagePayload,
  status?: TOutcomingStatus,
) {
  const chatId = message.chatId;
  const chatMessages = removeMessageFromChat({
    messageId,
    messagesMap,
    chatMessages: state.openedChats[chatId].chatMessages,
  });

  return {
    ...state,
    openedChats: {
      ...state.openedChats,
      [chatId]: {
        ...state.openedChats[chatId],
        chatMessages: insertMessageIntoChatMessages({
          messagesMap,
          rawMessage: message,
          chatMessages,
          userId: state.user.userId,
          status,
        }),
      },
    },
  };
}
